/**
 * API Base Configuration
 * Framework-agnostic API endpoint definitions
 */

/**
 * Environment-specific base URLs
 * Change this based on your deployment environment
 */
export const API_BASE_URLS = {
  production: 'https://api.hubadmin.bigcitytrade3.bigcityvoucher.co.in/v1/',
  staging: 'https://api.bigcityloyaltypro.in/v1/',
  uat: 'https://uat.api.hubadmin.bigcitytrade.bigcityvoucher.co.in/v1/',
  demo: 'https://hubadminapi.bigcitytrade.bigcitydays.in/v1/',
  development: 'http://localhost/bigcitytrade_hubadmin_api_2.0/web/v1/',
  local: 'http://192.168.1.145/v1/',
  // http://192.168.1.138:8080/
  // local: 'http://192.168.1.117:8080/v1/',
  //192.168.1.117
} as const;

/**
 * File Download Base URLs (without /v1/ path)
 * Used for downloading files directly from storage
 */
export const FILE_DOWNLOAD_BASE_URLS = {
  production: 'https://api.hubadmin.bigcitytrade3.bigcityvoucher.co.in',
  staging: 'https://api.bigcityloyaltypro.in',
  uat: 'https://uat.api.hubadmin.bigcitytrade.bigcityvoucher.co.in',
  demo: 'https://hubadminapi.bigcitytrade.bigcitydays.in',
  development: 'http://localhost/bigcitytrade_hubadmin_api_2.0/web',
  local: 'http://192.168.1.145',
} as const;

/**
 * Current active environment
 * Change this to switch environments
 */
export const ACTIVE_ENVIRONMENT: keyof typeof API_BASE_URLS = 'staging'; // Change to 'production', 'uat', 'demo', 'development' as needed

/**
 * Active base URL based on environment
 */
export const API_BASE_URL = API_BASE_URLS[ACTIVE_ENVIRONMENT];

/**
 * Active file download base URL based on environment
 */
export const FILE_DOWNLOAD_BASE_URL = FILE_DOWNLOAD_BASE_URLS[ACTIVE_ENVIRONMENT];

/**
 * Additional URLs
 */
export const IMAGE_URL = 'https://api.hubadmin.bigcitytrade.bigcityvoucher.co.in';
export const COM_MATRIX_URL = 'http://127.0.0.1:8020/api/comunication';
